jQuery(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
		$('#header').addClass('header-scrolled');
	} else {
		$('#header').removeClass('header-scrolled');
	}

	if ($(this).scrollTop() > 100) {
		$('.back-to-top').fadeIn('slow');
	} else {
		$('.back-to-top').fadeOut('slow');
	}
});

!(function($) {
	"use strict";

	
})(jQuery);

document.addEventListener('DOMContentLoaded', ()=> {
	"use strict";
	
	if ($(window).scrollTop() > 100) {
		$('#header').addClass('header-scrolled');
	}
	
	$("#header").sticky({
		topSpacing: 0,
		zIndex: '50'
	});
});

jQuery(function ($) {
	
});